document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".pluro-footer .footer-content__top .footer-block__menu_header .footer-block__heading").forEach(function(heading) {
    heading.addEventListener("click", function() {
      var parentMenu = heading.closest('.footer-block__menu_header');
      if (parentMenu.classList.contains('active')) {
        parentMenu.classList.remove('active');
      } else {
        document.querySelectorAll('.footer-block__menu_header').forEach(function(menu) {
          menu.classList.remove('active');
        });
        parentMenu.classList.add('active');
      }
    });
  });
});

// video list




// Product 

document.addEventListener('click', function (event) {

  const planItem = event.target.closest('.selling_plan_option');

  if (planItem && planItem.closest('.custom_prod_selling_palns')) {
    var thisVal = planItem.getAttribute('value');

    /* Remove selected from siblings */
    var siblings = planItem.parentElement.querySelectorAll('.selling_plan_option');
    siblings.forEach(function (sibling) {
      sibling.classList.remove('selected');
    });

    /* Add selected */
    planItem.classList.add('selected');

    /* Sync with Recharge dropdown */
    var selectElement = document.querySelector('.rc-selling-plans-dropdown__select');

    if (selectElement) {
      selectElement.value = thisVal;
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }

  }

});

function hideRechargeWidget() {
    let elements = document.querySelectorAll('.recharge-subscription-widget > div > .rc-widget .rc-template__radio');
    if (elements.length > 0) {
        let container = document.querySelector('.pluro-product .recharge-subscription-widget');
        if (container) {
            container.style.display = 'none';
        }
        observer.disconnect(); 
    }
}

const observer = new MutationObserver(hideRechargeWidget);
observer.observe(document.body, { childList: true, subtree: true });
hideRechargeWidget();

var checkExist3 = setInterval(function () {
  var element = document.querySelector('.recharge-subscription-widget > div > .rc-widget .rc-template__radio');
  if (element) {
    document.querySelectorAll('.custom_prod_selling_palns').forEach(el => el.style.display = 'block');
    clearInterval(checkExist3);
  }
}, 500);

let optionTypeLoadExist = document.querySelectorAll('.pluro-product .recharge-subscription-widget .rc-widget .rc-template__radio .rc-radio.rc-radio--active input').length;
if (optionTypeLoadExist > 0) {
  var checkExist = setInterval(function() {
    var rcWidget = document.querySelectorAll('.recharge-subscription-widget > div > .rc-widget');
    if (rcWidget.length) {
      var optionTypeLoad = document.querySelector('.pluro-product .recharge-subscription-widget .rc-widget .rc-template__radio .rc-radio.rc-radio--active input').value;
  
      if (optionTypeLoad === 'subscription') {
        document.querySelector('.custom_prod_selling_palns').style.display = 'block';
        document.querySelector('.variant__wrapper .rc-widget').style.display = 'block';
        document.querySelector('.variant__wrapper .variant__button .selling_price').style.display = 'inline-block';
      } else {
        document.querySelector('.custom_prod_selling_palns').style.display = 'none';
        document.querySelector('.variant__wrapper .rc-widget').style.display = 'none';
        document.querySelector('.variant__wrapper .variant__button .selling_price').style.display = 'none';
      }
      clearInterval(checkExist);
    }
  }, 100);
}

document.addEventListener('click', function(event) {
  if (event.target.matches('.custom_subscription_options .subscription_pan_item')) {
    let dataType = event.target.getAttribute('data-type');
    // console.log('Clicked element data-type:', dataType);
    let siblings = event.target.parentElement.querySelectorAll('.subscription_pan_item');
    siblings.forEach(function(sibling) {
      sibling.classList.remove('active');
    });
    event.target.classList.add('active');
    const radioButton = document.querySelector('.recharge-subscription-widget .rc-radio input[value="' + dataType + '"]');
    if (radioButton) {
      radioButton.click();
    }
    console.log('dataType::'+dataType);
    const productText = document.querySelector('.custom-subscription-text .product__text');
    if (dataType === 'onetime') {
      document.querySelector('.custom_prod_selling_palns').style.display = 'none';
      // document.querySelector('.custom-subscription-text .product__text').style.display = 'none';
      if (productText) {
        productText.style.display = 'none';
      }
      document.querySelectorAll('.variant__wrapper .variant__button .selling_price').forEach(el => {
        el.style.display = 'none';
      });
      document.querySelectorAll('.variant__wrapper .variant__button .price--on-sale').forEach(el => {
        el.classList.add('regular-price');
      });
      // document.querySelectorAll('.variant__wrapper .variant__button .variant___price').classList.add('regular-price');
    } else {
      document.querySelector('.custom_prod_selling_palns').style.display = 'block';
      document.querySelectorAll('.variant__wrapper .variant__button .selling_price').forEach(el => {
        el.style.display = 'inline-block';
      });
      document.querySelectorAll('.variant__wrapper .variant__button .price--on-sale').forEach(el => {
        el.classList.remove('regular-price');
      });
      // document.querySelector('.custom-subscription-text .product__text').style.display = 'inline-block';
      if (productText) {
        productText.style.display = 'inline-block';
      }
    }
  }
});


// Step Feature 
document.addEventListener("DOMContentLoaded", function() {

  const subscribeTab = document.querySelector('[data-type="subscription"]');
  const oneTimeTab = document.querySelector('[data-type="onetime"]');

  const step1 = document.querySelector('.subscription-step-1');
  const step2 = document.querySelector('.subscription-step-2');

  const nextBtn = document.querySelector('.next-step-btn');
  const backBtn = document.querySelector('.go-back-btn');
  const checkoutBtn = document.querySelector('.go-checkout-btn');

  const addToCartBtn = document.querySelector('[name="add"]');

  function activateSubscribeMode() {
      step1.style.display = "block";
      step2.style.display = "none";
      addToCartBtn.style.display = "none";
      nextBtn.style.display = "block";
  }

  function activateOneTimeMode() {
      step1.style.display = "block";
      step2.style.display = "none";
      addToCartBtn.style.display = "block";
      nextBtn.style.display = "none";
  }

  // FIX: Check active tab on page load
  if (subscribeTab.classList.contains('active')) {
      activateSubscribeMode();
  } else {
      activateOneTimeMode();
  }

  // =============================
  // TAB CLICKS
  // =============================
  subscribeTab.addEventListener('click', function() {
      activateSubscribeMode();
  });

  oneTimeTab.addEventListener('click', function() {
      activateOneTimeMode();
  });

  // =============================
  // NEXT
  // =============================
  nextBtn.addEventListener('click', function() {
      step1.style.display = "none";
      step2.style.display = "block";
  });

  // =============================
  // BACK
  // =============================
  backBtn.addEventListener('click', function() {
      step2.style.display = "none";
      step1.style.display = "block";
  });

  // =============================
  // DIRECT CHECKOUT
  // =============================
  checkoutBtn.addEventListener('click', function() {
      // Select the main product container
      const productWrapper = document.querySelector('product-info');
      
      // Declare formData variable in the outer scope so it's accessible by the fetch call
      let formData; 

      // Look for the subscription step 2 container inside the product wrapper
      const step2Container = productWrapper ? productWrapper.querySelector('.subscription-step-2') : null;

      // Check if the subscription step exists and find the currently selected option
      const selectedOption = step2Container ? step2Container.querySelector('.selling_plan_option.selected') : null;

      if (selectedOption) {
          // CASE 1: Subscription option is selected
          // Extract data directly from the selected element's data attributes
          const variantId = selectedOption.getAttribute('data-variant-id');
          const sellingPlanId = selectedOption.getAttribute('data-selling-plan-id');

          // Manually construct the FormData object
          formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);
          
          // Append selling plan if it exists
          if (sellingPlanId) {
              formData.append('selling_plan', sellingPlanId);
          }

      } else {
          // CASE 2: No subscription step or no option selected
          // Fallback to the default Add to Cart form
          const form = document.querySelector('form[action="/cart/add"]');
          
          if (form) {
              // Automatically grab all inputs from the existing form
              formData = new FormData(form);
          }
      }

      // Only proceed if formData was successfully defined in one of the cases above
      if (formData) {
          // Use Shopify AJAX API to add the item
          fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(res => {
              // Handle server-side errors (e.g., product out of stock)
              if (!res.ok) { return res.json().then(err => { throw err; }); }
              return res.json();
          })
          .then(response => {
              // Redirect to the checkout page after successful addition
              window.location.href = '/checkout';
          })
          .catch(error => {
              console.error('Add to cart error:', error);
              // Alert the user if the item couldn't be added
              alert('Error: ' + (error.description || 'Could not add product to cart. Please try again.'));
          });
      } else {
          console.error('Error: No product data found to submit.');
      }
  });

});